import NotOptimized from "../pages/NotOptimized";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate, useLocation } from "react-router-dom";
import { useWindowDimensions } from "../helpers/helpers";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const { width } = useWindowDimensions();
  const { user } = useAuthenticator();

  if (user === undefined) {
    return null; // Auth lädt noch
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (width < 870) {
    return <NotOptimized />;
  }

  return children;
}
